/**
 * 收藏
 */
const favorites = {
    namespaced: true,
    state: {
        favoritesName: "",
        favoritesId: null,
        favoritesIndex: 0,
        favoritesAmount: 0,
        pictureId: [],
        pictureIndex: 0,
        pictureAmount: 0,
        pictureUrl: "",
        favariteEnterCardShow: false,
        currentPictureFavorite: false,
        currentPictureFavoriteId: 0,
        favoritesStatus: {},
        favoritesEnterCardName: ""
    },
    mutations: {
        updateFavoritesName(state, name) {
            state.favoritesName = name;
        },
        updateFavoritesId(state, id) {
            state.favoritesId = id;
        },
        updateFavoritesIndex(state, index) {
            state.favoritesIndex = index;
        },
        updateFavoritesAmount(state, amount) {
            state.favoritesAmount = amount;
        },

        updatePictureId(state, id) {
            state.pictureId = id;
        },
        updatePictureIndex(state, index) {
            state.pictureIndex = index;
        },
        updatePictureAmount(state, amount) {
            state.pictureAmount = amount;
        },
        updateFavariteEnterCardShow(state, show) {
            state.favariteEnterCardShow = show;
        },
        updateFavoritesStatus(state, obj) {
            state.favoritesStatus = obj;
        },
        updateFavoritesEnterCardName(state, name) {
            state.favoritesEnterCardName = name;
        }
    }
};
export default favorites;
